<template>
    <section class="main-perfil">               
        <figure>
            <h3>{{dadosEmpresa.Razao_Social}}</h3>
            <img src="./../assets/profile_large.png" alt="" class="img-perfil">
            <figcaption>
                <h3>{{dadosTecnico.nome_tecnico}}</h3>
                <h3>{{dadosTecnico.cidade}} {{dadosTecnico.uf}}</h3>
            </figcaption>        
            <button class="btn" @click="logout()">Logout <img src="./../assets/user-logout-white.png"></button>
        </figure>
        
    </section>
</template>

<script>
import api from '../services/api.js';

export default {
  data: () => ({
      codTecnico: 22,
      dadosTecnico:{},
      dadosEmpresa:{},      
  }),
  methods: {
    logout(){
        localStorage.removeItem('usuarioLogado');    
        localStorage.removeItem('codUsuarioLogado'); 
    
        this.$router.push('/');
        window.location.reload();         
    },         
      async pegarTecnico(){
            try {
                let dados = {codTecnico: this.codTecnico}
                const response = await api.post('tecnico',dados); // Aguarda a resposta da API
                console.log(response);

                this.dadosTecnico = response.data;

                       

            } catch (error) {
                console.log(error);
                alert('Error - listar \n' + '-' + error.response?.data || error.message);
            }
      },     
      async pegarEmpresa(){
            try {
                const response = await api.get('empresa'); // Aguarda a resposta da API
                console.log(response);

                this.dadosEmpresa = response.data;

                       

            } catch (error) {
                console.log(error);
                alert('Error - listar empresa \n' + '-' + error.response?.data || error.message);
            }
      }    
    
  },
  mounted() {
      

    
  },  
  async created(){
      this.codTecnico =  localStorage.getItem('codUsuarioLogado');
      await this.pegarTecnico();
      await this.pegarEmpresa();
  }
}
</script>

<style>
    @import '../css/components/main-perfil.css';
</style>